import React from 'react';
import ReactMarkdown from 'react-markdown';

import { bemBlock, useTheme } from '@neptune/shared/venus-ui';

import defaultRenderers from './renderers';

import './MarkdownRenderer.less';

export type MarkdownRendererProps = {
  remarkPlugins?: React.ComponentProps<typeof ReactMarkdown>['remarkPlugins'];
  renderers?: React.ComponentProps<typeof ReactMarkdown>['components'];
  className?: string;
  content?: string;
};

const block = bemBlock('markdown-renderer');

export const MarkdownRenderer = ({
  content,
  className,
  remarkPlugins,
  renderers = defaultRenderers,
}: MarkdownRendererProps) => {
  const { theme } = useTheme();
  const githubCssClassName = 'markdown-body';

  React.useLayoutEffect(() => {
    import(`github-markdown-css/github-markdown-${theme}.css`).catch();
  }, [theme]);

  return (
    <ReactMarkdown
      className={block({ extra: [githubCssClassName, className] })}
      remarkPlugins={remarkPlugins}
      components={renderers}
    >
      {content}
    </ReactMarkdown>
  );
};
